module.exports = __webpack_public_path__ + "static/media/GlobalSearchW.d372b091.png";